import {IExtensionPoints, IPlugin, IServiceConfig} from "@athena-portal/core";
import {
    BaseRequestServiceImpl,
    CustomerPortalServiceImpl,
    IBaseRequestService,
    ICustomerPortalService,
    IPluginHelperService,
    PluginHelperServiceImpl,
    Types
} from "@falcon/services";
import {DashboardPage} from "../pages/dashboard/subscription/DashboardPage";
import {AnnualMotorDashboardPage} from "../pages/dashboard/annual/motor/dashboardPage/AnnualMotorDashboardPage";
import {IDashboardPluginConfig} from "./IDashboardPluginConfig";
import {AnnualAccountDetailsPage} from "../pages/dashboard/annual/motor/AnnualAccountDetailsPage";
import {ChangeCardPage} from "../pages/dashboard/common/payments/changeCard/ChangeCardPage"
import {PaymentDetailsPage} from '../pages/dashboard/common/payments/paymentDetails/subscription/PaymentDetailsPage';
import {CoronaSupportPage} from "../pages/dashboard/CoronaSupportPage"
import {QuotesPage} from "../pages/dashboard/common/quotesPage/QuotesPage"
import {AnnualQuotesPage} from "../pages/dashboard/common/quotesPage/AnnualQuotesPage"
import {YourCarsPage} from "../pages/dashboard/subscription/motor/yourCarsPage/YourCarsPage";
import {DocumentsPage} from "../pages/dashboard/subscription/DocumentsPage";
import {YourCarCoversPage} from "../pages/dashboard/subscription/motor/yourCarCoversPage/YourCarCoversPage";
import {
    YourRentersCoversPage
} from "../pages/dashboard/subscription/renters/yourRentersCoverPage/YourRentersCoversPage";
import {PickClaimKindPage} from "../pages/dashboard/common/PickClaimKindPage";
import {ValuablesPage} from "../pages/dashboard/subscription/renters/valuablesPage/ValuablesPage";
import {MakeRentersClaimPage} from "../pages/dashboard/subscription/renters/rentersClaims/MakeRentersClaimPage";
import {WhenAndWhereClaimPage} from "../pages/dashboard/subscription/renters/rentersClaims/WhenAndWhereClaimPage";
import {ClaimSubmittedPage} from "../pages/dashboard/subscription/renters/rentersClaims/ClaimSubmittedPage";
import {CardConsentPage} from "../pages/dashboard/common/payments/changeCard/subscription/CardConsentPage";
import {WindscreenOrGlassPage} from "../pages/dashboard/subscription/motor/motorClaims/WindscreenOrGlassPage";
import {UrgentClaimPage} from "../pages/dashboard/subscription/motor/motorClaims/UrgentClaimPage";
import {WhenDidItHappenPage} from "../pages/dashboard/subscription/motor/motorClaims/WhenDidItHappenPage";
import {MotorClaimSubmittedPage} from "../pages/dashboard/subscription/motor/motorClaims/MotorClaimSubmittedPage";
import {CoverDetailsPage} from "../pages/dashboard/subscription/motor/motorClaims/CoverDetailsPage";
import {MissedPaymentPage} from "../pages/dashboard/common/payments/missedPayment/MissedPaymentPage";
import {ClaimsPage} from "../pages/dashboard/subscription/renters/rentersClaims/ClaimsPage";
import {SelectPolicyPage} from "../pages/dashboard/subscription/renters/rentersClaims/SelectPolicyPage";
import {PaymentProcessingPage} from "../pages/dashboard/common/payments/PaymentProcessingPage";
import {PickAnnualMotorClaimKindPage} from "../pages/dashboard/annual/motor/claims/PickAnnualMotorClaimKindPage";
import {WindscreenOrBreakdownClaimPage} from "../pages/dashboard/annual/motor/claims/WindscreenOrBreakdownClaimPage";
import {OtherClaimPage} from "../pages/dashboard/annual/motor/claims/OtherClaimPage";
import {ClaimCoverDetailsPage} from "../pages/dashboard/annual/motor/claims/ClaimCoverDetailsPage";
import {WhenDidAccidentHappenPage} from "../pages/dashboard/annual/motor/claims/WhenDidAccidentHappenPage";
import {AnnualMotorClaimSubmittedPage} from "../pages/dashboard/annual/motor/claims/AnnualMotorClaimSubmittedPage";
import {ViewOrGetQuotesPage} from "../pages/dashboard/common/quotesPage/ViewOrGetQuotesPage";
import {
    MonthlyPaymentsDetailsPage
} from "../pages/dashboard/common/payments/paymentDetails/annual/MonthlyPaymentsDetailsPage";
import {YourCarCoverPage} from "../pages/dashboard/annual/motor/yourCarCover/YourCarCoverPage";
import {AnnualYourCarsPage} from "../pages/dashboard/annual/motor/yourCarsPage/AnnualYourCarsPage";
import {AnnualDocumentsPage} from "../pages/dashboard/annual/motor/documents/AnnualDocumentsPage";
import {
    AnnualPaymentDetailsPage
} from "../pages/dashboard/common/payments/paymentDetails/annual/AnnualPaymentDetailsPage";
import {StartPaymentPage} from "../pages/dashboard/common/payments/StartPaymentPage";
import {ExistingCardPaymentPage} from "../pages/dashboard/common/payments/ExistingCardPaymentPage";
import {NewCardPaymentPage} from "../pages/dashboard/common/payments/NewCardPaymentPage";
import {OldMotorPoliciesPage} from "../pages/dashboard/annual/motor/oldPolicies/OldMotorPoliciesPage";
import {OldMotorPolicySummaryPage} from "../pages/dashboard/annual/motor/oldPolicies/OldMotorPolicySummaryPage";
import {OldHomePoliciesPage} from "../pages/dashboard/annual/home/oldPolicies/OldHomePoliciesPage";
import {OldHomePolicySummaryPage} from "../pages/dashboard/annual/home/oldPolicies/OldHomePolicySummaryPage";
import {MultiPoliciesDashboardPage} from "../pages/dashboard/common/MultiPoliciesDashboardPage";
import {AccountDetailsPage} from "../pages/dashboard/subscription/AccountDetailsPage";
import {MultiPolicyAccountDetailsPage} from "../pages/dashboard/common/MultiPolicyAccountDetailsPage";
import {GetNewQuotePage} from "../pages/dashboard/common/quotesPage/GetNewQuotePage";
import {AnnualHomeDashboardPage} from "../pages/dashboard/annual/home/AnnualHomeDashboardPage";
import {PickAnnualHomeClaimKindPage} from "../pages/dashboard/annual/home/claims/PickAnnualHomeClaimKindPage";
import {ClaimDetailsPage} from "../pages/dashboard/annual/home/claims/ClaimDetailsPage";
import {HomeClaimSubmittedPage} from "../pages/dashboard/annual/home/claims/HomeClaimSubmittedPage";
import {AnnualHomeAccountDetailsPage} from "../pages/dashboard/annual/home/AnnualHomeAccountDetailsPage";
import {HomePolicySummaryPage} from "../pages/dashboard/annual/home/policySummary/HomePolicySummaryPage";
import {DirectDebitChangePaymentDayPage} from "../pages/dashboard/common/payments/DirectDebitChangePaymentDayPage";
import {PayOffBalancePage} from "../pages/dashboard/common/payments/payOffBalance/PayOffBalancePage";
import {PayOffBalanceNewCardPage} from "../pages/dashboard/common/payments/payOffBalance/PayOffBalanceNewCardPage";
import {CardPaymentProcessingPage} from "../pages/dashboard/common/payments/CardPaymentProcessingPage";
import {
    PayOffBalanceProcessingPage
} from "../pages/dashboard/common/payments/payOffBalance/PayOffBalanceProcessingPage";
import {MarketingPreferencesPage} from "../pages/dashboard/common/MarketingPreferencesPage";
import {DirectDebitChangePage} from "../pages/dashboard/common/payments/changeDirectDebit/DirectDebitChangePage";
import {PayOverdueInstalmentPage} from "../pages/dashboard/common/payments/missedPayment/PayOverdueInstalmentPage";
import {OutstandingPaymentPage} from "../pages/dashboard/common/payments/missedPayment/OutstandingPaymentPage";
import {AnnualHomeDocumentsPage} from "../pages/dashboard/annual/home/documents/AnnualHomeDocumentsPage";
import {HomeInsuranceQuotesPage} from "../pages/dashboard/common/quotesPage/HomeInsuranceQuotesPage";
import {OldPoliciesDashboardPage} from "../pages/dashboard/common/OldPoliciesDashboardPage";
import {
    DirectDebitRenewalChangePaymentDayPage
} from "../pages/dashboard/common/payments/DirectDebitRenewalChangePaymentDayPage";
import {
    CancelPolicyOrAutomaticRenewalPage
} from "../pages/dashboard/common/CancelPolicyOrAutomaticRenewalPage";
import {AllianzAdvantagePage} from "../pages/dashboard/common/advantages/AllianzAdvantagePage";
import {AllianzPromotionPage} from "../pages/AllianzPromotionPage";

const plugin: IPlugin<IDashboardPluginConfig> = {
    getName(): string {
        return "dashboard";
    },

    register(extensions: IExtensionPoints, configuration: IDashboardPluginConfig): void {
        // Routes
        extensions.routes.add(
            {
                path: "/dashboard",
                component: MultiPoliciesDashboardPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/allianzPromotion",
                component: AllianzPromotionPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotor/:policyNumber",
                component: AnnualMotorDashboardPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/:policyNumber",
                component: AnnualHomeDashboardPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/monthlySubscription",
                component: DashboardPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/rentersClaims",
                component: ClaimsPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/rentersClaims/new",
                component: MakeRentersClaimPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/rentersClaims/whenAndWhere",
                component: WhenAndWhereClaimPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/rentersClaims/whenAndWhere/claimSuccess",
                component: ClaimSubmittedPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/windscreen",
                component: WindscreenOrGlassPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/windscreen/urgent",
                component: UrgentClaimPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/otherClaims",
                component: OtherClaimPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/otherClaims/coverDetails",
                component: ClaimCoverDetailsPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/otherClaims/coverDetails/occur",
                component: WhenDidAccidentHappenPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/otherClaims/coverDetails/occur/success",
                component: AnnualMotorClaimSubmittedPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/windscreen/urgent/coverDetails",
                component: CoverDetailsPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/windscreen/urgent/coverDetails/occur",
                component: WhenDidItHappenPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/windscreen/urgent/coverDetails/occur/success",
                component: MotorClaimSubmittedPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/pickClaimKind",
                component: PickClaimKindPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/selectCoverage",
                component: SelectPolicyPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/pickAnnualMotorClaimKind/:policyNumber",
                component: PickAnnualMotorClaimKindPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/wolfWindscreenOrBreakdownPage/:policyNumber",
                component: WindscreenOrBreakdownClaimPage,
                exact: true,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/yourCars",
                component: YourCarsPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotor/yourCars/:policyNumber",
                component: AnnualYourCarsPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/yourCarCovers",
                component: YourCarCoversPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/advantages",
                component: AllianzAdvantagePage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotor/policySummary/:policyNumber",
                component: YourCarCoverPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotorOldPolicies",
                component: OldMotorPoliciesPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotorOldPolicies/:policyNumber",
                component: OldMotorPolicySummaryPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualHomeOldPolicies",
                component: OldHomePoliciesPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualHomeOldPolicies/:policyNumber",
                component: OldHomePolicySummaryPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/yourRentersCovers",
                component: YourRentersCoversPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/:product/cancel/:policyNumber",
                component: CancelPolicyOrAutomaticRenewalPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/valuables",
                component: ValuablesPage,
                exact: true
            }
        );


        extensions.routes.add(
            {
                path: "/dashboard/account",
                component: AccountDetailsPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/multiPolicy/account",
                component: MultiPolicyAccountDetailsPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/marketing-preferences",
                component: MarketingPreferencesPage,
                exact: true
            }
        )
        extensions.routes.add(
            {
                path: "/dashboard/annualMotorAccount/:policyNumber",
                component: AnnualAccountDetailsPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/account/:policyNumber",
                component: AnnualHomeAccountDetailsPage,
                exact: true
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/account/cardConsent",
                component: CardConsentPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard/:policyNumber/:paymentReference",
                component: ChangeCardPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard/:policyNumber",
                component: ChangeCardPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard2/:paymentReference",
                component: ChangeCardPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard",
                component: ChangeCardPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changePaymentDay/:policyNumber",
                component: DirectDebitChangePaymentDayPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeRenewalPaymentDay/:policyNumber",
                component: DirectDebitRenewalChangePaymentDayPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/missedPayment",
                component: MissedPaymentPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/missedPolicyPayment/:policyNumber",
                component: MissedPaymentPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/missedPolicyPayment/:policyNumber/:invoiceId",
                component: MissedPaymentPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/payOverdueInstalment/:policyNumber",
                component: PayOverdueInstalmentPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/payOverdueInstalment/:policyNumber/:invoiceId",
                component: PayOverdueInstalmentPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/outstandingPayment/:policyNumber",
                component: OutstandingPaymentPage,
                exact: true
            }
        );


        extensions.routes.add(
            {
                path: "/dashboard/account/missedPayment/:paymentReference",
                component: MissedPaymentPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing",
                component: PaymentProcessingPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing/:paymentReference",
                component: PaymentProcessingPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing/:paymentReference/:policyNumber",
                component: PaymentProcessingPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing/:paymentReference/:policyNumber/:invoiceId",
                component: PaymentProcessingPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/startPayment/:policyNumber",
                component: StartPaymentPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/existingCardPayment/:policyNumber",
                component: ExistingCardPaymentPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/newCardPayment/:policyNumber",
                component: NewCardPaymentPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/:policyNumber/cardPaymentProcessing",
                component: CardPaymentProcessingPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/:policyNumber/cardPaymentProcessing/:paymentReference",
                component: CardPaymentProcessingPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/paymentHistory",
                component: PaymentDetailsPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualPaymentHistory/:policyNumber",
                component: AnnualPaymentDetailsPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/monthlyPaymentHistory/:policyNumber",
                component: MonthlyPaymentsDetailsPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/paymentDetails/editDirectDebit/",
                component: DirectDebitChangePage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/corona",
                component: CoronaSupportPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/quotes",
                component: QuotesPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualQuotes",
                component: AnnualQuotesPage,
                exact: true
            }
        );

        extensions.routes.add({
            path: "/dashboard/viewOrGetQuotes",
            component: ViewOrGetQuotesPage,
            exact: true
        });

        extensions.routes.add({
            path: "/dashboard/HomeInsuranceQuotes",
            component: HomeInsuranceQuotesPage,
            exact: true
        });

        extensions.routes.add(
            {
                path: "/dashboard/documents",
                component: DocumentsPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotorDocuments/:policyNumber",
                component: AnnualDocumentsPage,
                exact: true
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualHomeDocuments/:policyNumber",
                component: AnnualHomeDocumentsPage,
                exact: true
            }
        );

        extensions.routes.add({
            path: "/dashboard/getNewQuote",
            component: GetNewQuotePage,
            exact: true
        });

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/:policyNumber/claims/new",
                component: PickAnnualHomeClaimKindPage,
                exact: true
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/:policyNumber/claims/details",
                component: ClaimDetailsPage,
                exact: true
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/:policyNumber/claims/submitted",
                component: HomeClaimSubmittedPage,
                exact: true
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/policySummary/:policyNumber",
                component: HomePolicySummaryPage,
                exact: true
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/payOffBalance",
                component: PayOffBalancePage,
                exact: true
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/payOffBalance/newCard",
                component: PayOffBalanceNewCardPage,
                exact: true
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/payOffBalance/processing/:paymentReference",
                component: PayOffBalanceProcessingPage,
                exact: true
            }
        );

        extensions.routes.add({
            path: "/dashboard/annualOldPolicies",
            component: OldPoliciesDashboardPage,
            exact: true,
        });

        // Services
        extensions.services.bind<ICustomerPortalService>(Types.CustomerPortalService).to(CustomerPortalServiceImpl);
        extensions.services.bind<IServiceConfig>(Types.CustomerPortalServiceConfig).toConstantValue(configuration.customerPortalApiService);

        extensions.services.bind<IPluginHelperService>(Types.PluginHelperService).to(PluginHelperServiceImpl);
        extensions.services.bind<IBaseRequestService>(Types.BaseRequestService).to(BaseRequestServiceImpl);
    },
};

export default plugin;



// WEBPACK FOOTER //
// ./src/config/dashboardPlugin.ts